import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import logo from "../assests/footer-logo.png"

const Footer = () => {
  const navigate = useNavigate();
  
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4 }
    }
  };

  const linkHoverVariants = {
    hover: {
      scale: 1.05,
      color: '#3B82F6',
      transition: { duration: 0.2 }
    }
  };

  return (
    <motion.footer 
      className="bg-gray-100 py-16 px-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Logo and Description Column */}
          <motion.div 
            className="md:col-span-1"
            variants={itemVariants}
          >
            <div className="flex items-center mb-4">
            
       <motion.h1
  className="h-12 flex items-center justify-center"
>
  <img 
    src={logo} 
    alt="Vidyut Systems Logo" 
    className="h-full w-auto object-contain" 
  />
</motion.h1>

  
            </div>
            <motion.p 
              className="text-gray-600 text-sm leading-relaxed"
              variants={itemVariants}
            >
              Powering the future with reliable, efficient, and advanced power solutions for homes and businesses.
            </motion.p>
          </motion.div>

          {/* About Us Column */}
          <motion.div variants={itemVariants}>
            <h4 className="text-gray-800 font-semibold mb-4">About Us</h4>
            <ul className="space-y-3">
              <li>
                <motion.button 
                  onClick={() => navigate('/about')}
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors text-left"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  About Us
                </motion.button>
              </li>
              <li>
                <motion.button 
                  onClick={() => navigate('/contact-us')}
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors text-left"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Contact Us
                </motion.button>
              </li>
              <li>
                <motion.button 
                  onClick={() => navigate('/Products')}
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors text-left"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Products
                </motion.button>
              </li>
            </ul>
          </motion.div>

          {/* Products Column */}
          <motion.div variants={itemVariants}>
            <h4 className="text-gray-800 font-semibold mb-4">Products</h4>
            <ul className="space-y-3">
              <li>
                <motion.button 
                  onClick={() => navigate('/Products', { state: { category: 'bms' } })}
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors text-left"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  BMS
                </motion.button>
              </li>
              <li>
                <motion.button 
                  onClick={() => navigate('/Products', { state: { category: 'solar-controllers' } })}
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors text-left"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Solar Controllers
                </motion.button>
              </li>
              <li>
                <motion.button 
                  onClick={() => navigate('/Products', { state: { category: 'single-phase' } })}
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors text-left"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Single Phase
                </motion.button>
              </li>
              <li>
                <motion.button 
                  onClick={() => navigate('/Products', { state: { category: 'three-phase' } })}
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors text-left"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Three Phase
                </motion.button>
              </li>
            </ul>
          </motion.div>

          {/* Social Media Column */}
          <motion.div variants={itemVariants}>
            <h4 className="text-gray-800 font-semibold mb-4">Social Media</h4>
            <ul className="space-y-3">
              <li>
                <motion.a 
                  href="#" 
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Instagram
                </motion.a>
              </li>
              <li>
                <motion.a 
                  href="#" 
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Facebook
                </motion.a>
              </li>
              <li>
                <motion.a 
                  href="#" 
                  className="text-gray-600 text-sm hover:text-blue-500 transition-colors"
                  variants={linkHoverVariants}
                  whileHover="hover"
                >
                  Twitter
                </motion.a>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Section */}
        <motion.div 
          className="border-t border-gray-300 pt-8 flex flex-col md:flex-row justify-between items-center"
          variants={itemVariants}
        >
                      <motion.p 
            className="text-gray-600 text-sm mb-4 md:mb-0"
            whileHover={{ scale: 1.02 }}
          >
            Copyright @2025 Vidyut Systems
          </motion.p>
          
          <div className="flex space-x-6">
            <motion.a 
              href="#" 
              className="text-gray-600 text-sm hover:text-blue-500 transition-colors"
              variants={linkHoverVariants}
              whileHover="hover"
            >
              Privacy
            </motion.a>
            <motion.a 
              href="#" 
              className="text-gray-600 text-sm hover:text-blue-500 transition-colors"
              variants={linkHoverVariants}
              whileHover="hover"
            >
              Security
            </motion.a>
            <motion.a 
              href="#" 
              className="text-gray-600 text-sm hover:text-blue-500 transition-colors"
              variants={linkHoverVariants}
              whileHover="hover"
            >
              Terms
            </motion.a>
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;